/*
  Mecca Books Help nav — click-to-highlight (matches the source
  prototype's behavior exactly: visual active state on click, no
  real scroll-spy).
*/
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mb-help-nav]').forEach(function (nav) {
      nav.addEventListener('click', function (e) {
        var link = e.target.closest('.mb-help__nav-link');
        if (!link) return;
        nav.querySelectorAll('.mb-help__nav-link').forEach(function (a) {
          a.classList.remove('mb-help__nav-link--active');
        });
        link.classList.add('mb-help__nav-link--active');
      });
    });
  });
})();